type ContentProps = {
  children: React.ReactNode;
  id?: string;
};

export const Content = ({ children, id }: ContentProps) => {
  return (
    <div id={id} className='mb-8 flex flex-1 flex-col gap-5 pt-5 sm:flex-none'>
      {children}
    </div>
  );
};
